import localStorage from 'local-storage';

// если пользователь не не авторизован, то необходимо самим отчищать протухшие брони
function removeExpiredOrders(orders) {
  const actualOrders = orders.filter((order) => {
    if (!order.reservationEndTime) {
      return false;
    }

    return Date.now() - order.reservationEndTime < 0;
  });

  localStorage.set('unconfirmedOrders', actualOrders);

  return actualOrders;
}

// чтобы не дублировались брони, которые пришли с бэка и уже существущие в LS
function removeExistingOrders(orders, ordersFromLS) {
  const ordersLSIds = ordersFromLS.map((orderLS) => orderLS.id);

  return orders.filter((order) => !ordersLSIds.includes(order.id));
}

export function saveUnconfirmedOrdersInLocalStorage(orders) {
  const ordersFromLS = localStorage.get('unconfirmedOrders') ?? [];

  const newOrders = removeExistingOrders(orders, ordersFromLS);
  const actualOrders = removeExpiredOrders(ordersFromLS);

  // если новая бронь в LS уже есть, то не нужно повторно записывать
  if (!newOrders.length) {
    return;
  }

  const actualOrdersIds = actualOrders.map((order) => order.id);

  const filteredOrders = [...actualOrders, ...newOrders].filter((item) => {
    if (item.type) {
      return (
        !actualOrdersIds.includes(item.id) || (actualOrders.includes(item.id) && item.isRemoved)
      );
    }

    return true;
  });

  const mergedOrders = filteredOrders.sort((a, b) => a.reservationEndTime - b.reservationEndTime);

  localStorage.set('unconfirmedOrders', mergedOrders);
}

export function getUnconfirmedOrdersFromLocalStorage() {
  const ordersFromLS = localStorage.get('unconfirmedOrders') ?? [];

  return removeExpiredOrders(ordersFromLS.filter((order) => Boolean(order.product)));
}

// если скрыли баннер, то isRemoved = true и не удаляем его из LS, пока бронь не протухнет
export function setUnconfirmedOrderHidden(id) {
  const ordersFromLS = localStorage.get('unconfirmedOrders') ?? [];

  const mappedOrdersFromLS = ordersFromLS.map((order) => {
    if (order.id === id || !id) {
      return {
        ...order,
        isRemoved: true,
      };
    }

    return order;
  });

  localStorage.set('unconfirmedOrders', mappedOrdersFromLS);
}
